export const CSS = {
  container: "container",
  content: "content",
};
